import * as React from 'react';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { FilterCommonProps } from '../types';
import { FilterTypes } from 'app/components/filters/types';
import { customFilterFieldPostfix, userProfileProperties } from 'app/components/filters/filters-panel/constants';

export class FilterDomain extends React.Component<FilterCommonProps, {}> {

  private getOptionPropertyName(type: FilterTypes) {
    const types = {
      [FilterTypes.MyUnit]: userProfileProperties.unit,
      [FilterTypes.MyLocation]: userProfileProperties.location,
      [FilterTypes.Person]: userProfileProperties.person
    };

    return types[type];
  }

  private getOptionPropertyTitle(type: FilterTypes) {
    const types = {
      [FilterTypes.MyUnit]: this.props.translation.filters_my_unit,
      [FilterTypes.MyLocation]: this.props.translation.filters_my_location,
      [FilterTypes.Person]: this.props.translation.filters_person
    };

    return types[type];
  }

  private createOptionPropertyValue(optionPropertyName: string) {
    const { userProfile, filterDomain } = this.props;
    const types = {
      [FilterTypes.Person]: { value: userProfile.id, description: userProfile.name }
    };

    return types[filterDomain.advancedSearchType] || userProfile[optionPropertyName];
  }

  private createOptionProperty() {
    const { filterDomain } = this.props;
    const optionPropertyName = this.getOptionPropertyName(filterDomain.advancedSearchType);
    const optionPropertyTitle = this.getOptionPropertyTitle(filterDomain.advancedSearchType);    

    return { ...this.createOptionPropertyValue(optionPropertyName), title: optionPropertyTitle };
  }

  public render() {
    const {
      filterDomain,
      optionsEndpoint,
      optionsParams,
      simpleFormComponent: SimpleForm,
      initialValue,
      userProfile,
      translation,
      filterDomain: { id: name }
    } = this.props;

    const staticOptions = [this.createOptionProperty()];

    const useProfileValue = initialValue && initialValue.some(v => v.myValue);
    const initialValues = initialValue && initialValue.filter(v => !v.myValue);

    return <div>
      {!!userProfile && <SimpleForm
        name={name + customFilterFieldPostfix.userProfile}
        type={FIELD_TYPE.CHECKBOX_LIST}
        initialValue={useProfileValue ? staticOptions : []}
        staticOptions={staticOptions.length > 0 && staticOptions}
      />}
      <SimpleForm
        name={name}
        type={FIELD_TYPE.SELECT_MULTIPLE_HIERARCHY}
        initialValue={initialValues}
        optionsEndpoint={optionsEndpoint}
        placeholder={translation && translation.filters_search_placeholder}
        translation={translation}
        optionsParams={optionsParams}
        descriptionAllLevels={true}
        searchRequired={filterDomain.searchRequired}        
      />
    </div>;
  }
}
